import React from 'react';
import { Mui } from '@osu/react-ui';

/**
 * Header component for the Student Dashboard
 * Displays title, user welcome message, and admin indicators
 */
function DashboardHeader({ 
  user, 
  isAdminOverride = false, 
  scenarioSelector = null 
}) {
  return (
    <Mui.Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        mb: 4,
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <Mui.Box>
        {/* Title and welcome message - different for admin vs student view */}
        {isAdminOverride ? (
          <Mui.Typography
            variant="h4"
            sx={{
              color: "primary.main",
              mb: 1
            }}
            id="main-content"
          >
            Viewing Student Dashboard
          </Mui.Typography>
        ) : user?.name && (
          <Mui.Typography
            variant="h4"
            sx={{
              color: "primary.main",
              mb: 1
            }}
            id="main-content"
          >
            Welcome, {user.name}
          </Mui.Typography>
        )}
      </Mui.Box>

      {/* Scenario Selector for Testing - Hide in admin view */}
      {scenarioSelector && !isAdminOverride && (
        <Mui.Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "flex-end",
          }}
        >
          {scenarioSelector}
        </Mui.Box>
      )}
    </Mui.Box>
  );
}

export default DashboardHeader;